export default {"src":"/_next/static/media/weth-nftfy.52dfb07f.svg","height":53,"width":54};